const intlCache: Record<string, Intl.NumberFormat> = {};

export interface FormatCurrencyArg {
  currency: string;
  amount: number | { toNumber: () => number }; // Stand in for a Decimal interface
  hideDecimals?: boolean;
}

export interface CurrencySymbolArg {
  currency: string;
  amount: number;
  locale: string;
}

export const getCurrencySymbol = ({
  currency,
  amount,
  locale,
}: CurrencySymbolArg) =>
  new Intl.NumberFormat(locale, { style: 'currency', currency: currency })
    .formatToParts(amount)
    .find((a) => a.type === 'currency')?.value;

export function formatCurrency(
  { currency, amount, hideDecimals = false }: FormatCurrencyArg,
  locale?: string | null
): string {
  // Force consistent prefixed for $ and £. Without this en-GB gives 'US$' which is not what we want.
  const currencyLocale =
    locale ?? currency === 'USD'
      ? 'en-US'
      : currency === 'GBP'
        ? 'en-GB'
        : locale ?? 'en-US';

  const intlKey = `${currencyLocale}-${currency}`;

  let formatter = intlCache[intlKey];

  if (!formatter) {
    const options: Intl.NumberFormatOptions = {
      style: 'currency',
      currency,
    };
    if (hideDecimals) {
      options.minimumFractionDigits = 0;
      options.maximumFractionDigits = 0;
    }
    formatter = new Intl.NumberFormat(currencyLocale, options);

    intlCache[intlKey] = formatter;
  }

  return formatter.format(
    typeof amount === 'number' ? amount : amount.toNumber()
  );
}
